export default __webpack_public_path__ + "static/media/DSC_0526.5a3d4a9c.jpg";